import { ReactElement } from 'react';
import { Backdrop, Box, IconButton, Modal } from '@mui/material';

import styles from './ModalVideo.module.scss';
import { Close } from '@mui/icons-material';

interface IProps {
  autoplay: boolean;
  muted: boolean;
  videoId: string;

  isOpen: boolean;
  onClose?(): void;
}

export const ModalVideo = (props: IProps): ReactElement => {
  let { isOpen, onClose, videoId, autoplay, muted } = props;
  const src = `https://player.vimeo.com/video/${videoId}?h=unlisted_hash&muted=${muted ?? false}&autoplay=${autoplay ?? false}&fullscreen=true`;

  const handleClose = (): void => {
    videoId = '';
    autoplay = null;
    muted = null;
    onClose?.();
  };

  return (
    <Modal
      className={styles.modalVideo}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      slots={{
        backdrop: Backdrop,
      }}
    >
      <Box className={styles.modalVideoBody}>
        <Box className={styles.modalVideoInner}>
          <Box className={styles.modalVideoWrap}>
            <iframe
              width="460"
              height="230"
              src={src}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              tabIndex={-1}
            />
            <IconButton
              className={styles.modalVideoCloseBtn}
              onClick={handleClose}
              aria-label="Close the modal by clicking here"
            >
              <Close fontSize="large" />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
